import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  "@global": {
    ".MuiDialogContent-root:first-child": {
      padding: 0,
    },
  },
  online: {
    fontSize: 11,
    color: "#25d366",
  },
  offline: {
    fontSize: 11,
    color: "#e1306c",
  },
  icon: {
    color: theme.palette.neutral300,
  },
  buttonBox: {
    paddingBottom: "16px",
    paddingTop: "16px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "0px",
    paddingRight: "0px",
    marginLeft: "0px",
  },
  button: {
    letterSpacing: "-0.25%",
    lineHeight: "24px",
    fontFamily: "Roboto",
    fontSize: "16px",
    textTransform: "none",
    minWidth: "100%",
    height: "40px",
    borderRadius: "12px",
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  dialog: {
    backgroundColor: theme.palette.background200,
    borderRadius: "16px",
    margin: 0,
    position: "absolute",
    top: 0,
    right: 0,
    maxWidth: "400px",
    display: "flex",
    flexDirection: "column",
    height: "100vh", // Full height of the viewport
  },
  header: {
    display: "flex",
    backgroundColor: theme.palette.background100,
    height: "73px",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2, 3),
  },
  title: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "25px",
    letterSpacing: "-0.25%",
    color: theme.palette.neutral400,
  },
  content: {
    backgroundColor: theme.palette.background200,
    overflow: "hidden",
  },
  backgroundBotoes: {
    backgroundColor: theme.palette.background100,
  },
  buttonsContainer: {
    backgroundColor: theme.palette.background100,
    height: "72px",
    borderTop: `1px solid ${theme.palette.neutral200}`,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  fieldLabel: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
  filterRow: {
    marginBottom: "24px",
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  checkbox: {
    borderRadius: "50%",
  },
  autocomplete: {
    backgroundColor: theme.palette.background100,
    borderRadius: "12px",
    height: "52px",
    justify: "Space-between",

    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      height: "52px",
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.neutral300,
      },
    },
    "& .MuiInputBase-input": {
      "&::placeholder": {
        color: theme.palette.neutral400,
        opacity: 1,
      },
    },
  },
  maxWidth: {
    width: "100%",
  },
}))

export default useStyles
